const devConfig = {
  apiUrl: "https://clashdle-node-api-development.up.railway.app",
  apiKey: process.env.API_KEY as string
};

export default devConfig;
